import React from "react"
import { ThemeProvider } from "emotion-theming"
import theme from "@rebass/preset"
import { Box } from "rebass"
import "../layout.css"
import "../typography.css"
import "flickity/dist/flickity.min.css"
import HoverCursor from "../images/cursor-hover.png"

const uncannyTheme = {
  ...theme,
  fonts: {
    body: "agipo, system-ui, sans-serif",
    heading: "curvy, system-ui, sans-serif",
  },
  buttons: {
    transparent: {
      background: "transparent",
      borderRadius: 0,
      padding: 0,
      ":disabled": {
        opacity: 0.5,
        cursor: "not-allowed",
      },
    },
    submit: {
      fontSize: [2, 3],
      borderRadius: 0,
      color: "white",
      background: "black",
      padding: 3,
      width: "100%",
      cursor: `url(${HoverCursor}), auto`,
      span: {
        transition: "color .2s ease-in, text-shadow .2s ease-in",
      },
      "&:hover span, &:focus span": {
        textShadow: "#fff 0 0 10px",
        color: "transparent",
      },
    },
  },
  variants: {
    hashtag: {
      background: "#000",
      display: "inline-flex",
      color: "white",
      padding: 2,
      fontSize: 3,
      pointerEvents: "none",
      boxShadow: `10px 20px 40px 0 rgba(6,6,6,0.59)`,
      borderRadius: "6px",
      fontFamily: "body",
    },
    tourDate: {
      fontFamily: "body",
      fontSize: [3, 4],
    },
    excerptWrap: {
      maxWidth: "calc(100% - 50px)",
    },
    excerptInner: {
      maxWidth: "80ch",
      margin: "0 auto",
    },
    hyperlink: {
      textDecoration: "none",
      fontFamily: "body",
      fontSize: [2, 3],
      color: "text",
      span: {
        transition: "color .2s ease-in, text-shadow .2s ease-in",
      },
      "&:hover span, &:focus span": {
        textShadow: "#000 0 0 10px",
        color: "transparent",
      },
    },
    footer: {
      textDecoration: "none",
      fontFamily: "body",
      fontSize: [3, 3],
      color: "white",
      span: {
        transition: "color .2s ease-in, text-shadow .2s ease-in",
      },
      "&:hover span, &:focus span": {
        textShadow: "#fff 0 0 10px",
        color: "transparent",
      },
    },
  },
  text: {
    hyperlink: {
      textDecoration: "none",
    },
    error: {
      fontFamily: "body",
      color: "red",
    },
    footer: {
      fontFamily: "body",
      fontSize: [3, 3],
      color: "white",
    },
    article: {
      fontFamily: "body",
      fontSize: [3, 4],
      lineHeight: 1.7,
    },
    excerpt: {
      fontFamily: "body",
      fontSize: [2, 3],
      lineHeight: [1.45, 1.7],
      marginBottom: 4,
      marginTop: 4,
    },
    snippet: {
      fontFamily: "body",
      textAlign: "center",
      fontSize: [4, 5],
      lineHeight: [1.35, 1.4],
    },
    quote: {
      fontFamily: "body",
      fontSize: [2, 3],
      textAlign: "center",
      lineHeight: 1.75,
    },
    gridItem: {
      fontFamily: "body",
      fontSize: [2, 3],
      userSelect: "none",
    },
    title: {
      fontWeight: 400,
      fontSize: [150, 200],
      lineHeight: 0.55,
      userSelect: "none",
      pointerEvents: "none",
      "&:before": {
        content: "''",
        display: "block",
        height: 0,
        width: 0,
        marginBottom: [-50, -70],
      },
      "&:after": {
        content: "''",
        display: "block",
        height: 0,
        width: 0,
        marginTop: [50, 75],
      },
    },
  },
}

const Layout = ({ children }) => {
  return (
    <ThemeProvider theme={uncannyTheme}>
      <Box css={{ overflowX: "hidden" }}>{children}</Box>
    </ThemeProvider>
  )
}

export default Layout
